import { FEATURED_OFFERS_502X272_VIEW } from './types';

export const featuredOffers502x272IsViewed = (deal, dealsLength) => ({
  type: FEATURED_OFFERS_502X272_VIEW,
  deal,
  dealsLength,
});
